import React from 'react';

const SupportPage = () => {
  return (
    <iframe
      src="/support.html"
      title="Honey - Support & FAQ"
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
        display: 'block'
      }}
    />
  );
};

export default SupportPage;
